'use client'

import { LanguageISO6391 } from 'ai-constants'
import React, { createContext, useContext, useEffect, useMemo } from 'react'
import { I18nextProvider } from 'react-i18next'
import { changeI11nLanguage, getI11nInstance } from '../client-i18n'

export interface LanguageContextProps {
  lang: LanguageISO6391
}

export const LanguageContext = createContext<LanguageContextProps | undefined>(
  undefined,
)

export const useLanguage = () => useContext(LanguageContext)!

export const LanguageProvider = ({
  children,
  ...props
}: {
  children: React.ReactNode
} & LanguageContextProps) => {
  const i18n = getI11nInstance()
  const contextValue = useMemo(() => ({ lang: props.lang }), [props.lang])

  useEffect(() => {
    void changeI11nLanguage(props.lang)
  }, [i18n, props.lang])

  return (
    <I18nextProvider i18n={i18n}>
      <LanguageContext.Provider value={contextValue}>
        {children}
      </LanguageContext.Provider>
    </I18nextProvider>
  )
}
